export default "__VITE_ASSET__85acc9e6__"